var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameschermButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "clipp-ath": "url(#clip0_736_4251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 0H5.66667C2.53672 0 0 2.53672 0 5.66667V31.1667C0 34.2966 2.53672 36.8333 5.66667 36.8333H18.7974L17.9474 41.0833H13.4583C12.2896 41.0833 11.3333 42.0396 11.3333 43.2083C11.3333 44.3771 12.2896 45.3333 13.4583 45.3333H37.5417C38.7148 45.3333 39.6667 44.3815 39.6667 43.2083C39.6667 42.0352 38.7148 41.0833 37.5417 41.0833H33.0499L32.2026 36.8333H45.3333C48.4633 36.8333 51 34.2966 51 31.1667V5.66667C51 2.53672 48.4589 0 45.3333 0ZM28.7141 41.0833H22.2859L23.1359 36.8333H27.8694L28.7141 41.0833ZM46.75 31.1667C46.75 31.9478 46.1144 32.5833 45.3333 32.5833H5.66667C4.88555 32.5833 4.25 31.9478 4.25 31.1667V26.9167H46.75V31.1667ZM46.75 22.6667H4.25V5.66667C4.25 4.88555 4.88555 4.25 5.66667 4.25H45.3333C46.1144 4.25 46.75 4.88555 46.75 5.66667V22.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_736_4251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 45.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameschermButton);
export default __webpack_public_path__ + "static/media/gamescherm-button.6a32bb34cc62c2824f8ddc453f4162dc.svg";
export { ForwardRef as ReactComponent };